/**
 *
 * 中信建投
 *
 */

import { getUrlParam } from '@/utils/api';
import { isBuild } from '@/utils/const';

const comein_channel = 'zhongxinjt';

export const isThirdParty = getUrlParam().comein_channel === comein_channel;

function Bridge() {
	this.title = '中信建投';

	this.comein_channel_pc = 'zxjt';

	this.comein_channel = comein_channel;

	this.authMethod = 1;

	// 以前部分接口需要传zid、后面改成传uc
	this.zid = isBuild ? 76 : 478;
	this.uc = isBuild ? 'c5f8c504-ec84-4f2d-aa58-6294e037c857' : '43edcb82-41a8-4933-ad82-846c74482560';

	this.instituteLogin = {
		loginWay: [0]
	};

	this.bindPhone = {
		// 登录方式，0：手机号，1：邮箱
		loginWay: [0]
	};
}

// 获取分享配置
Bridge.prototype.getShareData = function () {
	return {
		title: '中信建投证券',
		desc: '中信建投证券以“引领专业投资、研究创造价值”为服务理念，建立了具有鲜明特色的宏观策略、固定收益、行业和上市公司研究体系和数据支持体系，凭借独树一帜的专业化研究成果和国际化视角赢得了社会各界和公司客户的广泛认可。',
		link: location.href,
		img_url: 'https://resource.comein.cn/comein-files/img/default/zhongxinlogo.png'
	};
};

export default Bridge;
